import { jaHira } from "../../../../date-fns/locale/ja-Hira.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    jaHira
  }
};